import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { DeviceService } from '../../../features/shared/services/device.service';
import { DateHelper, StringHelper } from 'apps/idl/src/helpers';
import { ETimetablePattern, IContact } from 'apps/idl/src/model';
import { DestroyableComponentBase } from 'apps/idl/src/modules/utils/components/destroyable-component-base';
import { DateObject } from '../../../models/retrocession/DateObject';

@Component({
    selector: 'di-list-seances-retrocession',
    templateUrl: './list-seances-retrocession.component.html',
    styleUrls: ['./list-seances-retrocession.component.scss'],
})
export class ListSeancesRetrocessionComponent extends DestroyableComponentBase implements OnInit, OnChanges {
    @Input() public journees: { date: Date, dateObject: DateObject }[];
    @Input() public pourcentageActesMajorations: number;
    @Input() public pourcentageIndemnites: number;
    @Input() public infirmier: IContact;

    public isMobile: boolean = false;
    public infirmierFirstName: string = "";
    public journeesDisplayed: {date: string, dateObject: DateObject}[];
    
    constructor(private svcDevice: DeviceService) {
        super();
     }
    
    ngOnInit(): void {
        this.svcDevice.isMobile$.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((flag: boolean) => {
            this.isMobile = flag;
        });
    }
    
    ngOnChanges(changes: SimpleChanges): void {
        if(this.infirmier?.firstName){
            this.infirmierFirstName = StringHelper.toTitleCase(this.infirmier.firstName);
        }
        if(this.journees) this.formatDates();
    }

    private formatDates(): void {
        this.journeesDisplayed = this.journees.map((journee: {date: Date, dateObject: DateObject}) => ({
            ...journee,
            date: DateHelper.transform(journee.date, ETimetablePattern.dd_MMM_yyyy)
        }));
    }
}